<div class="h-25">
  <div class="fixed top-0 right-0 left-0 z-10 w-full bg-white shadow-1" *transloco="let t">
    <div class="h-layout">
      <div class="flex h-25 items-center justify-between">
        <a class="mr-sm block w-[126px] cursor-pointer" [routerLink]="linkService.homePath">
          <img alt="Buildigo" ngSrc="assets/images/buildigo.svg" height="30" width="126" class="object-cover" />
        </a>
        <div class="hidden grow md:block">
          <ng-content></ng-content>
        </div>
        <div>
          <button class="-mr-sm btn btn-ghost" (click)="close()">
            {{ t('calculators.navbar.close') }}
            <fa-icon [icon]="closeIcon" class="ml-md text-lg"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
